import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';

const breathingTextStyle = {
    '@keyframes breathe': {
        from: { opacity: 0.4 },
        to: { transform: 0.7 }
    },

    root:{
        animationName: 'breathe',
        animationDuration: '0.5s',
        animationIterationCount: 'infinite',
        animationDirection: 'alternate',
    }

}


export default withStyles(breathingTextStyle)(Typography);